<template>
    <a v-if="type == 2" href="javascript:;" @click="telConfirm">{{ note }}</a>
    <a v-else href="javascript:;" @click="telConfirm"></a>
</template>

<script>

    import { Dialog } from 'vant'

    export default {
        name: "TelConfirm",
        props: ['tel', 'type', 'note'],
        methods: {
            telConfirm () {
                const _this = this;
                Dialog.confirm({
                    title: '400转接',
                   // message: _this.note,
                   message: '',
                    confirmButtonText: '确定'
                }).then(() => {
                    window.location.href = "tel:" + _this.tel;
                }).catch(()=>{});
            },
        }
    }
</script>

<style scoped>

</style>